import * as React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { MdDownload, MdFileDownload, MdLockOutline, MdOutlineFileDownload, MdVisibility, MdVisibilityOff } from "react-icons/md";
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { ThemeProvider } from '@mui/material/styles';
import { CircularProgress, FormControl, IconButton, InputAdornment, InputLabel, Modal, OutlinedInput, Stack } from '@mui/material';
import RtlProvider from '../Components/RtlProvider';
import { ContextNotification, severitys } from '../App';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';
import logo from "../assets/logo.png"
import UserApi from '../api/UserApi';
import CustomLink from '../Components/CustomLink';
import CustomDownloadLink from '../Components/CustomDownloadLink';
import { VscEye, VscEyeClosed } from "react-icons/vsc";
import helper from '../helper';
import RoleSelecting from './RoleSelecting';
import enumMapper from '../enumMapper';
import Header from './Header';
import themes from '../themes';

const Login = () => {
    const { open, setOpen } = React.useContext(ContextNotification);
    const schema = yup.object().shape({
        username:yup.string().trim().required("لطفا نام کاربری را وارد نمایید"),
        password:yup.string().trim().required("لطفا رمز عبور را وارد نمایید"),
        captchaValue: yup.string().trim().required("متن تصویر فوق را وارد نمایید")
    });
    const { register, formState: { errors }, handleSubmit, watch } = useForm({
        resolver: yupResolver(schema),
    });
    const [loading, setLoading] = React.useState(false);

    const [openRolesModal, SetOpenRolesModal] = React.useState(false);
    const [roleInfo, setRoleInfo] = React.useState(null);

    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };

    const navigate = useNavigate();
    React.useEffect(() => {
        loadCaptchaEnginge(4, '#E9ECE0', '#A800B8', 'numbers');
        handleloggedIn();
    }, []);

    const handleloggedIn = () => {
        var Token = localStorage.getItem("token") ?? null;
        if (Token) navigate("/dashboard");
    }

    const onSubmit = (Data) => {  
        if (SubmitCaptcha(Data.captchaValue))
        submitUser(Data.username, Data.password);
    };
    function SubmitCaptcha(captchavalue) {
        if (validateCaptcha(captchavalue) === true) {
            return true;
        }
        else {
            setOpen({ IsEnable: true, Message: 'متن تصویر نادرست است', severity: severitys.error });
            loadCaptchaEnginge(4, '#E9ECE0', '#A800B8', 'numbers');
            return false
        }
    };

    const submitUser = (username, password) => {
        setLoading(true);
        return (
            UserApi.Login(username, password, enumMapper.AppId.GuestService)
                .then((res) => {
                    localStorage.setItem("token", res.data.access_token);
                    window.location.pathname = "/Dashboard/Home";
                })
                .catch(err => {
                    setLoading(false);
                    if ((err.response) && (err.response.status == 422)) {
                        const arr = helper.DictionayToList(err.response.data);
                        const roles = arr.map((o) => {
                            return {
                                id: o.key,
                                title: o.value
                            };
                        });
                        handleOpenRoleModal({ username: watch('username'), password: watch('password'), roleIDS: roles });
                    }
                    else {
                        setOpen({ IsEnable: true, Message: 'نام کاربری یا رمز عبور نادرست است', severity: severitys.error });
                        loadCaptchaEnginge(4, '#E9ECE0', '#A800B8', 'numbers');
                    }
                }).finally(() => { })
        );
    }

    const DownloadFile = () => {
        const pdfUrl = "files/avamel-help.pdf";
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = "راهنما.pdf"; // specify the filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const handleOpenRoleModal = (e) => {
        setRoleInfo(e);
        SetOpenRolesModal(true);
    };
    const handleCloseRoleModal = () => {
        SetOpenRolesModal(false);
        setRoleInfo(null);
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '400px',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 6,
        pt: 2,
        px: 4,
        pb: 3,
        height: '50%',
    };

    return (
        <ThemeProvider theme={themes.defaultTheme}>
            <Box sx={{ minHeight: "100vh", bgcolor: "white" }}>
                {/* Header */}
                <Header visible={true} title={"ثبت نام"} href={"/register/guest"} />

                {/* Main login form */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        px: { xs: 2, sm: 3 },
                        py: { xs: 4, sm: 6 },
                    }}
                >
                    {/* Flat login container */}
                    <Box
                        sx={{
                            width: "100%",
                            maxWidth: 360,
                            px: 3,
                            py: 4,
                            bgcolor: "white",
                            borderRadius: 0.5, // minimal radius
                            border: "1.5px solid #0c3353", // visible border
                            boxShadow: "0 1px 2px rgba(0,0,0,0.05)", // very subtle shadow
                        }}
                    >
                        <Stack spacing={3}>
                            <Typography
                                variant="myTitle"
              textAlign="center"
              fontWeight={700}
              color="black"
              fontSize={20}
                            >
                                ورود
                            </Typography>
                            <RtlProvider>
                                <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate>
                                    <TextField
                                        margin="normal"
                                        required
                                        fullWidth
                                        label="نام کاربری"
                                        {...register("username")}
                                        error={!!errors.username?.message}
                                            helperText={errors.username?.message}
                                        autoFocus
                                    />
                                    <TextField
                                        margin="normal"
                                        required
                                        fullWidth
                                        label="رمز عبور"
                                        type={showPassword ? 'text' : 'password'}
                                        {...register("password")}
                                        error={!!errors.password?.message}
                                            helperText={errors.password?.message}
                                        autoComplete="current-password"

                                        InputProps={{
                                            endAdornment: <InputAdornment position="start"><IconButton
                                                aria-label={
                                                    showPassword ? 'hide the password' : 'display the password'
                                                }
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                                onMouseUp={handleMouseUpPassword}
                                                edge="end"
                                            >
                                                {showPassword ? <VscEye /> : <VscEyeClosed />}
                                            </IconButton></InputAdornment>,
                                        }}
                                    />
                                    <div>
                                        <div style={{ fontSize: '12px', textAlign: 'center' }}> <LoadCanvasTemplate reloadText="بارگذاری مجدد" reloadColor="blue" /></div>
                                        <TextField
                                            margin="normal"
                                            required
                                            fullWidth
                                            label="متن تصویر فوق را وارد کنید"
                                            {...register("captchaValue")}
                                            error={!!errors.captchaValue?.message}
                                            helperText={errors.captchaValue?.message}
                                            autoFocus
                                        />
                                    </div>
                                    <Button
                                        disabled={loading}
                                        type="submit"
                                        fullWidth
                                        variant="contained"
                                        color='primary'
                                        sx={{ mt: 3, mb: 2 }}
                                    >
                                        <Typography sx={{ display: "flex", alignItems: "center" }}>
                                            ورود به سامانه
                                            {loading && <CircularProgress color="inherit" size="20px" sx={{ mx: '0.5rem' }} />}
                                        </Typography>
                                    </Button>
                                </Box>
                            </RtlProvider>
                            <Modal
                                alignItems='center'
                                open={openRolesModal}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box sx={modalStyle}>
                                    <Typography id="modal-modal-description" >

                                        <RoleSelecting roleInfo={roleInfo} />
                                        <Button sx={{ marginTop: 3, marginRight: 30 }} onClick={handleCloseRoleModal}>بستن</Button>
                                    </Typography>
                                </Box>
                            </Modal>
                        </Stack>
                    </Box>
                </Box>
            </Box>
        </ThemeProvider>
    );
}
export default Login;